export { default as ChangePasswordForm } from './component';
